
export const auth = {
  signIn: 'Sign in',
  signUp: 'Create account',
  email: 'Email',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  forgotPassword: 'Forgot password?',
  noAccount: "Don't have an account?",
  hasAccount: 'Already have an account?',
  signInWithGoogle: 'Sign in with Google',
  signUpWithGoogle: 'Sign up with Google',
  resetPassword: 'Reset Password',
  backToSignIn: 'Back to Sign In',
  resetEmailSent: 'Password reset email sent',
  invalidCredentials: 'Invalid email or password',
  emailAlreadyExists: 'An account with this email already exists',
  passwordTooWeak: 'Password should be at least 6 characters',
  genericError: 'An error occurred. Please try again.',
  signInSuccess: 'Successfully signed in!',
  signUpSuccess: 'Account created successfully!',
  signOutSuccess: 'Successfully signed out!',
  fullName: 'Full Name',
  companyName: 'Company Name',
  companySize: 'How many people work in the company?',
  organization: 'Organization (Optional)',
  department: 'Department (Optional)',
  position: 'Position (Optional)',
  phone: 'Phone (Optional)',
  createAccount: 'Create account',
  alreadyRegistered: 'Already registered?',
  newPassword: 'New Password',
  updatePassword: 'Update Password',
  passwordUpdated: 'Password updated successfully!',
  resetEmailInstructions: 'Enter your email address and we\'ll send you a link to reset your password.',
  sendResetEmail: 'Send Reset Email',
  enterNewPassword: 'Enter your new password below.',
  checkEmail: 'Check your email for a password reset link.'
};
